// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9698) return "static/chunks/9698-a46cd0972b15964f.js";
	if (chunkId === 4208) return "static/chunks/4208-acbfe6db4211f527.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3179":"3ddc9f734b79f5cf","3389":"8e5f5e1c1c41d56a","7573":"3b441344de9eea9d"}[chunkId] + ".js";
};